import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen text-gray-800 px-6">
        <Header />
        <div className="max-w-3xl mx-auto bg-white p-8 my-[3rem] rounded-lg shadow-md">
            <h1 className="text-2xl sm:text-3xl font-semibold mb-4">Privacy Policy</h1>
            <p className="text-sm text-gray-500 mb-6">
            Takamori Robot<br />
            Effective Date: 11/09/2025
            </p>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">1. Information We Collect</h2>
            <ul className="list-disc pl-5">
                <li>Information you provide (e.g., name, email, payment info).</li>
                <li>Automatic data (IP, browser type, usage activity, cookies).</li>
            </ul>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">2. How We Use It</h2>
            <ul className="list-disc pl-5">
                <li>Operate and improve our services.</li>
                <li>Process payments and manage accounts.</li>
                <li>Communicate updates, support, and offers.</li>
            </ul>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">3. Sharing Information</h2>
            <p>
                We do not sell personal data. We share limited data with trusted service
                providers (hosting, analytics, payments) or when required by law.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">4. Cookies</h2>
            <p>
                We use cookies for analytics and functionality. You can disable cookies in
                your browser, but some features may not work properly.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">5. Data Security</h2>
            <p>
                We use reasonable measures to protect your data. We retain it only as long as
                necessary for legal or operational purposes.
            </p>
            </section>

            <section className="mb-4">
            <h2 className="font-semibold mb-1">6. Your Rights</h2>
            <p>
                You may request access, correction, or deletion of your data by contacting{" "}
                <span className="font-medium">joseph@takamorirobot.com</span>.
            </p>
            </section>

            <section>
            <h2 className="font-semibold mb-1">7. Contact</h2>
            <p>
                For privacy inquiries, email us at{" "}
                <span className="font-medium">joseph@takamorirobot.com</span>.
            </p>
            </section>
        </div>
        <Footer />
    </div>
  );
}
